// Frontend utility functions

export const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
  return new Date(dateStr).toLocaleDateString('ja-JP', options);
};

export const formatDateTime = (dateStr) => {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleString('ja-JP');
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('ja-JP', {
    style: 'currency',
    currency: 'JPY',
  }).format(Number(amount || 0));
};

export const calculateNights = (checkIn, checkOut) => {
  if (!checkIn || !checkOut) return 0;
  const checkInDate = new Date(checkIn);
  const checkOutDate = new Date(checkOut);
  const timeDiff = checkOutDate - checkInDate;
  return Math.max(0, Math.ceil(timeDiff / (1000 * 3600 * 24)));
};

export const truncateText = (text, maxLength = 100) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return `${text.substring(0, maxLength)}...`;
};

export const getStatusColor = (status) => {
  const colors = {
    confirmed: 'success',
    pending: 'warning',
    queued: 'secondary',
    awaiting_owner: 'info',
    cancelled: 'danger',
    completed: 'success',
    ical: 'info',
    paid: 'success',
    refunded: 'danger',
  };
  return colors[status] || 'secondary';
};

export const getStatusLabel = (status) => {
  const labels = {
    confirmed: '確定',
    pending: '保留',
    queued: '順番待ち',
    awaiting_owner: '承認待ち',
    cancelled: 'キャンセル',
    completed: '完了',
    ical: 'iCal',
    paid: '支払済',
    refunded: '返金済',
  };
  return labels[status] || status;
};

export const formatPhone = (phone) => {
  if (!phone) return '';
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 10) {
    return `${cleaned.substring(0, 3)}-${cleaned.substring(3, 6)}-${cleaned.substring(6)}`;
  }
  if (cleaned.length === 11) {
    return `${cleaned.substring(0, 3)}-${cleaned.substring(3, 7)}-${cleaned.substring(7)}`;
  }
  return phone;
};

export const validateEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

export const getInitials = (name) => {
  if (!name) return '';
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase();
};
